<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <h6 class="pt-3">Contact</h6>

        <div class="col-lg-2 col-md-4 col-sm-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="titles" formControlName="title" optionLabel="name"
              optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
            placeholder="Title"></p-dropdown>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



        <div class="col-lg-3 col-md-4 col-sm-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2 col-md-4 col-sm-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="middleName" id="middleName" type="text" pInputText>
            <label for="middleName">Middle Name</label>
            @for (validation of validationMessages.middleName; track validation) {
              <span>
                @if (form1.get('middleName').hasError(validation.type) && (form1.get('middleName').dirty || form1.get('middleName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2 col-md-4 col-sm-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="suffix" id="suffix" type="text" pInputText>
            <label for="suffix">suffix</label>
            @for (validation of validationMessages.suffix; track validation) {
              <span>
                @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6 col-md-8 col-sm-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="emailAddress" id="emailAddress" type="text" pInputText>
            <label for="emailAddress">Email Address</label>
            @for (validation of validationMessages.emailAddress; track validation) {
              <span>
                @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>
        <div class="col-lg-2 col-md-4 col-sm-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown [options]="countries" formControlName="countryCode" optionLabel="name"
              optionValue="dial" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Country Code">
            </p-dropdown>
            <label for="countryCode">Country Code</label>
            @for (validation of validationMessages.countryCode; track validation) {
              <span>
                @if (form1.get('countryCode').hasError(validation.type) && (form1.get('countryCode').dirty || form1.get('countryCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-6">
          <span class="p-float-label w-100 mb-3">
            <!-- <p-inputMask formControlName="mobilePhone" id="mobilePhone" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
          <label for="mobilePhone">Mobile Phone</label>
          @for (validation of validationMessages.mobilePhone; track validation) {
            <span>
              @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="notes" id="notes" [rows]="2" pInputTextarea></textarea>
          <label for="notes">Notes</label>
          @for (validation of validationMessages.notes; track validation) {
            <span>
              @if (form1.get('notes').hasError(validation.type) && (form1.get('notes').dirty || form1.get('notes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>


      <div class="col-lg-12">
        <h6 for="primaryContact">Primary Contact</h6>
        <div class="flex align-items-center">
          <p-checkbox [formControl]="form1.controls['primaryContact']" inputId="primaryContact" [binary]="true"></p-checkbox>
          <span class="guestProfile-nm">Primary Contact</span>
        </div>
        @for (validation of validationMessages.primaryContact; track validation) {
          <span>
            @if (form1.get('primaryContact').hasError(validation.type) && (form1.get('primaryContact').dirty || form1.get('primaryContact').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </div>

      <h6 class="pt-3">Address</h6>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="adrStreet" id="adrStreet" type="text" pInputText>
          <label for="adrStreet">Address Street</label>
          @for (validation of validationMessages.adrStreet; track validation) {
            <span>
              @if (form1.get('adrStreet').hasError(validation.type) && (form1.get('adrStreet').dirty || form1.get('adrStreet').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="adrStreet2" id="adrStreet2" type="text" pInputText>
          <label for="adrStreet2">Address Street2</label>
          @for (validation of validationMessages.adrStreet2; track validation) {
            <span>
              @if (form1.get('adrStreet2').hasError(validation.type) && (form1.get('adrStreet2').dirty || form1.get('adrStreet2').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-5 col-md-12 col-sm-12">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="adrCity" id="adrCity" type="text" pInputText>
          <label for="adrCity">Address City</label>
          @for (validation of validationMessages.adrCity; track validation) {
            <span>
              @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [options]="states" formControlName="adrState" optionLabel="name"
            optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="State">
          </p-dropdown>
          <label for="State">State</label>
          @for (validation of validationMessages.adrState; track validation) {
            <span>
              @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
          <label for="adrPostalCode">Postal Code</label>
          @for (validation of validationMessages.adrPostalCode; track validation) {
            <span>
              @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [options]="countries" formControlName="adrCountry" optionLabel="name" 
            optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Country">
          </p-dropdown>
          <label for="Country">Country</label>
          @for (validation of validationMessages.adrCountry; track validation) {
            <span>
              @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <span class="p-float-label w-100 mb-3">
          <!-- <p-inputMask formControlName="adrPhone" id="adrPhone" mask="(999) 999-9999" type="text">
        </p-inputMask> -->
        <input formControlName="adrPhone" id="adrPhone" type="text" pInputText>
        <label for="adrPhone">Address Phone</label>
        @for (validation of validationMessages.adrPhone; track validation) {
          <span>
            @if (form1.get('adrPhone').hasError(validation.type) && (form1.get('adrPhone').dirty || form1.get('adrPhone').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6 col-md-6 col-sm-12">
      <span class="p-float-label w-100 mb-3">
        <input formControlName="adrFax" id="adrFax" type="text" pInputText>
        <label for="adrFax">Address Fax</label>
        @for (validation of validationMessages.adrFax; track validation) {
          <span>
            @if (form1.get('adrFax').hasError(validation.type) && (form1.get('adrFax').dirty || form1.get('adrFax').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <h6 class="pt-3">Emergency Contact</h6>

    <div class="col-lg-6 col-md-6 col-sm-12">
      <span class="p-float-label required-field w-100 mb-3">
        <input formControlName="emergencyContactName" id="emergencyContactName" type="text" pInputText>
        <label for="emergencyContactName">Emergency Contact Name</label>
        @for (validation of validationMessages.emergencyContactName; track validation) {
          <span>
            @if (form1.get('emergencyContactName').hasError(validation.type) && (form1.get('emergencyContactName').dirty || form1.get('emergencyContactName').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

    <div class="col-lg-6 col-md-6 col-sm-12">
      <span class="p-float-label w-100 mb-3">
        <!-- <p-inputMask formControlName="emergencyContactPhone" id="emergencyContactPhone" mask="(999) 999-9999" type="text">
      </p-inputMask> -->
      <input formControlName="emergencyContactPhone" id="emergencyContactPhone" type="text" pInputText>
      <label for="emergencyContactPhone">Emergency Contact Phone</label>
      @for (validation of validationMessages.emergencyContactPhone; track validation) {
        <span>
          @if (form1.get('emergencyContactPhone').hasError(validation.type) && (form1.get('emergencyContactPhone').dirty || form1.get('emergencyContactPhone').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
  <div class="col-lg-12">
    <span class="p-float-label w-100 mb-3">
      <textarea formControlName="emergencyContactNotes" id="emergencyContactNotes" [rows]="2" pInputTextarea></textarea>
      <label for="emergencyContactNotes">Emergency Contact Notes</label>
      @for (validation of validationMessages.emergencyContactNotes; track validation) {
        <span>
          @if (form1.get('emergencyContactNotes').hasError(validation.type) && (form1.get('emergencyContactNotes').dirty || form1.get('emergencyContactNotes').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <h6 class="pt-3">Reason To Travel</h6>

  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <input formControlName="travelOccasion" id="travelOccasion" type="text" pInputText>
      <label for="travelOccasion">Travel Occasion</label>
      @for (validation of validationMessages.travelOccasion; track validation) {
        <span>
          @if (form1.get('travelOccasion').hasError(validation.type) && (form1.get('travelOccasion').dirty || form1.get('travelOccasion').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>
  <div class="col-lg-12">
    <span class="p-float-label w-100 mb-3">
      <textarea formControlName="travelOccasionNotes" id="travelOccasionNotes" [rows]="2" pInputTextarea></textarea>
      <label for="travelOccasionNotes">Travel Occasion Notes</label>
      @for (validation of validationMessages.travelOccasionNotes; track validation) {
        <span>
          @if (form1.get('travelOccasionNotes').hasError(validation.type) && (form1.get('travelOccasionNotes').dirty || form1.get('travelOccasionNotes').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>

  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <input formControlName="leadPurchaseOptIn" id="leadPurchaseOptIn" type="text" pInputText>
      <label for="leadPurchaseOptIn">Lead Purchase Opt In</label>
      @for (validation of validationMessages.leadPurchaseOptIn; track validation) {
        <span>
          @if (form1.get('leadPurchaseOptIn').hasError(validation.type) && (form1.get('leadPurchaseOptIn').dirty || form1.get('leadPurchaseOptIn').touched)) {
            <small class="p-invalid"
              >{{validation.message}}
            </small>
          }
        </span>
      }
    </span>
  </div>



</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (guestProfileId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger d-none"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!guestProfileId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (guestProfileId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>